import { Api } from '@/services/Api';

export default {
     /*  1. Get all data */
    getDiagnosisInformations(body = { keyword: '' }) {
        return Api().post('/DiagonisisInformation/GetDiagonisisInformationByCriteria', body)
    },
     /*  2. Get one column */
    getDiagnosisInformation(id) {
        return Api().get(`/DiagonisisInformation/${id}`);
    },
     /*  3. Create one column */
    saveDiagnosisInformation(body) {
        return Api().post(`/DiagonisisInformation`, body);
    },
    /*  4. Delete one or more columns */
    deleteDiagnosisInformation(diagnosisInformation) {
        return Api().post(`/DiagonisisInformation/DeleteDiagonisisInformation`, diagnosisInformation);
    },
    /*  5. post one or more columns */
    postDiagnosisInformation(diagnosisInformation) {
        return Api().post(`/DiagonisisInformation/PostDiagonisisInformation`, diagnosisInformation);
    }
}